module.exports = __webpack_public_path__ + "static/media/intro_picture.40d3720b.jpg";